module.exports = __webpack_public_path__ + "assets/icon-send.edd6b6a0.svg";